module.exports = "/css/fonts/nucleo-icons.ttf?f82ec6ba2dc4181db2af35c499462840";